import { useEffect, useRef } from "react";

export function useDebouncedEffect(
	effect: () => void | Promise<void>,
	deps: React.DependencyList,
	delay: number,
) {
	const callbackRef = useRef(effect);

	useEffect(() => {
		callbackRef.current = effect;
	}, [effect]);

	useEffect(() => {
		const handler = setTimeout(() => {
			callbackRef.current();
		}, delay);
		return () => {
			clearTimeout(handler);
		};
	}, [...deps, delay]);
}
